<template>
  <v-container grid-list-lg fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $t("pagesClients.edit.title") }}:
          {{
            company && company.organization_short_name
              ? company.organization_short_name
              : $t("pagesClients.edit.noData")
          }}
        </h1>
      </v-flex>
      <v-flex xs12 py-0>
        <v-divider />
      </v-flex>
    </v-layout>
    <span @click="$router.go(-1)" class="goback">
      {{ $t("pagesClients.edit.goBack") }}</span
    >

    <close-messages :type="4" />

    <v-layout row wrap>
      <v-flex xs12>
        <v-layout row wrap client__data>
          <v-flex
            @click="onClickTab('company')"
            :class="{
              'client__data-tab pb-0': true,
              active: this.activeTab === 'company',
            }"
          >
            <strong>{{ $t("pagesClients.edit.tabs.company") }}</strong>
          </v-flex>

          <v-flex
            v-if="isShowFinancial"
            @click="onClickTab('finances')"
            :class="{
              'client__data-tab pb-0': true,
              active: this.activeTab === 'finances',
            }"
          >
            <strong>{{ $t("pagesClients.edit.tabs.finances") }}</strong>
          </v-flex>
          <v-flex
            @click="onClickTab('documents')"
            :class="{
              'client__data-tab pb-0': true,
              active: this.activeTab === 'documents',
            }"
          >
            <strong>{{ $t("pagesClients.edit.tabs.documents") }}</strong>
          </v-flex>
          <v-flex
            @click="onClickTab('faces')"
            :class="{
              'client__data-tab pb-0': true,
              active: this.activeTab === 'faces',
            }"
          >
            <strong>{{ $t("pagesClients.edit.tabs.faces") }}</strong>
          </v-flex>
          <v-flex
            @click="onClickTab('bank')"
            :class="{
              'client__data-tab pb-0': true,
              active: this.activeTab === 'bank',
            }"
          >
            <strong>{{ $t("pagesClients.edit.tabs.bank") }}</strong>
          </v-flex>
          <v-flex
            @click="onClickTab('bids')"
            :class="{
              'client__data-tab pb-0': true,
              active: this.activeTab === 'bids',
            }"
          >
            <strong>{{ $t("pagesClients.edit.tabs.bids") }}</strong>
          </v-flex>
          <v-flex
            v-if="isShowTender"
            @click="onClickTab('tenders')"
            :class="{
              'client__data-tab pb-0': true,
              active: this.activeTab === 'tenders',
            }"
          >
            <strong>{{ $t("pagesClients.edit.tabs.tenders") }}</strong>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="activeTab === 'company'">
          <v-flex xs12 pt-0>
            <loading v-if="!companyLoaded" />
            <div class="block grid-list-lg" v-else>
              <my-company
                :company-data="company"
                v-on:nextTab="nextTab"
                :editMode="true"
                class="mt-3"
                v-if="company && !errors"
              />
              <h2 class="empty_title" v-if="errors && errors.length">
                <v-icon color="error">warning</v-icon>
                {{ $t("pagesClients.edit.companyError") }}: {{ errors }}
              </h2>
            </div>

            <v-layout row wrap justify-space-between py-4>
              <v-flex shrink>
                <!-- <v-btn @click="activeTab = 'aaaa'" color="primary" class="ml-0">Назад</v-btn> -->
              </v-flex>
              <v-flex shrink>
                <v-btn
                  @click="onCompanyToFinance"
                  color="primary"
                  class="mr-0"
                  >{{ $t("pagesClients.edit.next") }}</v-btn
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="activeTab === 'finances' && isShowFinancial">
          <v-flex xs12 pt-0>
            <loading v-if="!financesLoaded" />
            <div class="block" v-else>
              <finance
                :finance-data="finances"
                :editMode="true"
                :packageMode="false"
                :agentMode="client.inn"
                v-if="finances && !errors"
              />
              <h2 class="empty_title" v-if="errors && errors.length">
                <v-icon color="error">warning</v-icon>
                {{ $t("pagesClients.edit.financeError") }}: {{ errors }}
              </h2>
            </div>
            <v-layout row wrap justify-space-between py-4>
              <v-flex shrink>
                <v-btn @click="getCompany" color="primary" class="ml-0">{{
                  $t("pagesClients.edit.back")
                }}</v-btn>
              </v-flex>
              <v-flex shrink>
                <v-btn
                  @click="onCompanyToDocuments"
                  color="primary"
                  class="mr-0"
                  >{{ $t("pagesClients.edit.next") }}</v-btn
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="activeTab === 'documents'">
          <v-flex xs12 pt-0>
            <div class="block" v-if="!companyIsTax">
              <v-alert
                text
                color="warning"
                outlined
                dense
                border="left"
                transition="scale-transition"
                tile
                min-width="100%"
              >
                {{ $t("pagesClients.edit.documentAlert") }}
              </v-alert>
            </div>
            <div v-if="companyIsTax">
              <loading v-if="!documentsLoaded" />
              <div class="block" v-else>
                <div>
                  <v-alert
                    border="top"
                    colored-border
                    type="info"
                    elevation="2"
                  >
                    {{ $t("pagesClients.edit.documentAlertHelper") }}
                  </v-alert>
                </div>
                <my-documents
                  :documents-data="documents"
                  v-on:updateDocuments="updateDocuments"
                  :agentMode="client.inn"
                  v-if="documents && !errors"
                />
                <h2 class="empty_title" v-if="errors && errors.length">
                  <v-icon color="error">warning</v-icon>
                  {{ $t("pagesClients.edit.documentError") }}: {{ errors }}
                </h2>
              </div>
              <loading v-if="!licencesLoaded" />
              <div class="block mt-3 pt-4" v-else>
                <licences
                  :licences-data="licences"
                  v-on:updateLicences="updateLicences"
                  v-on:addLicence="addLicence"
                  v-on:addLicenceFile="addLicence"
                  :editMode="true"
                  :packageMode="false"
                  :agentMode="client.inn"
                  v-if="licences && !errors"
                />
                <h2 class="empty_title" v-if="errors && errors.length">
                  <v-icon color="error">warning</v-icon>
                  {{ $t("pagesClients.edit.licenseError") }}: {{ errors }}
                </h2>
              </div>
            </div>
            <v-layout row wrap justify-space-between py-4>
              <v-flex shrink>
                <v-btn
                  @click="isShowFinancial ? getFinances() : getCompany()"
                  color="primary"
                  class="ml-0"
                  >{{ $t("pagesClients.edit.back") }}</v-btn
                >
              </v-flex>
              <v-flex shrink>
                <v-btn @click="getFaces" color="primary" class="mr-0">{{
                  $t("pagesClients.edit.next")
                }}</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="activeTab === 'faces'">
          <v-flex xs12 pt-0>
            <loading v-if="!facesLoaded" />
            <div class="block" v-else>
              <h2>{{ $t("pagesClients.edit.faces") }}</h2>
              <faces
                :faces-data="faces"
                :agentMode="client.inn"
                :client-company="company"
                v-on:updateFaces="updateFaces"
                v-on:updateFacesAndFounders="updateFacesAndFounders"
                :editMode="true"
                v-if="faces && !errors"
              />
              <h2 class="empty_title" v-if="errors && errors.length">
                <v-icon color="error">warning</v-icon>
                {{ $t("pagesClients.edit.facesError") }}: {{ errors }}
              </h2>
            </div>

            <loading v-if="!ownersLoaded" />
            <div v-if="ownersLoaded && !isCompanyIndividual" class="block mt-5">
              <h2>{{ $t("pagesClients.edit.owners") }}</h2>
              <owners
                :owners-data="owners"
                :agentMode="client.inn"
                v-on:updateOwners="updateOwners"
                :editMode="true"
                v-if="owners && !errors"
              />
              <h2 class="empty_title" v-if="errors && errors.length">
                <v-icon color="error">warning</v-icon>
                {{ $t("pagesClients.edit.ownersError") }}: {{ errors }}
              </h2>
            </div>
            <v-layout row wrap justify-space-between py-4>
              <v-flex shrink>
                <v-btn @click="getDocuments" color="primary" class="ml-0">{{
                  $t("pagesClients.edit.back")
                }}</v-btn>
              </v-flex>
              <v-flex shrink>
                <v-btn @click="getBanks" color="primary" class="mr-0">{{
                  $t("pagesClients.edit.next")
                }}</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="activeTab === 'bank'">
          <v-flex xs12 pt-0>
            <loading v-if="!bankLoaded" />
            <div class="block" v-else>
              <legals
                :bank-data="bank"
                v-on:updateBanks="updateBanks"
                v-on:addBanks="addBanks"
                :editMode="true"
                :packageMode="false"
                :agentMode="client.inn"
                v-if="bank && !errors"
              />
              <h2 class="empty_title" v-if="errors && errors.length">
                <v-icon color="error">warning</v-icon>
                {{ $t("pagesClients.edit.bankError") }}: {{ errors }}
              </h2>
            </div>
            <v-layout row wrap justify-space-between py-4>
              <v-flex shrink>
                <v-btn @click="getFaces" color="primary" class="ml-0">{{
                  $t("pagesClients.edit.back")
                }}</v-btn>
              </v-flex>
              <v-flex shrink>
                <v-btn @click="getBids" color="primary" class="mr-0">{{
                  $t("pagesClients.edit.next")
                }}</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="activeTab === 'bids'">
          <v-flex xs12 pt-0>
            <div class="block">
              <close-messages :type="5" />
              <v-btn color="primary" @click="addBid">{{
                $t("pagesClients.edit.addBid")
              }}</v-btn>
              <loading v-if="!bidsLoaded && !bids" />
              <bids-list
                :bids="bids"
                :isAgentMode="true"
                v-if="bidsLoaded && bids && !errors"
              />
              <h2 class="empty_title" v-if="errors && errors.length">
                <v-icon color="error">warning</v-icon>
                {{ $t("pagesClients.edit.bidError") }}: {{ errors }}
              </h2>
            </div>
            <v-layout row wrap justify-space-between py-4>
              <v-flex shrink>
                <v-btn @click="getBanks" color="primary" class="ml-0">{{
                  $t("pagesClients.edit.back")
                }}</v-btn>
              </v-flex>
              <v-flex shrink>
                <!-- <v-btn @click="activeTab = 'aaaa'" color="primary" class="mr-0">Далее</v-btn> -->
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="activeTab === 'tenders'">
          <v-flex xs12 pt-0>
            <div class="block">
              <loading v-if="!tendersLoaded" />
              <client-tenders
                :tenders="tenders"
                v-if="tendersLoaded && tenders && !errors"
              />

              <h2 class="empty_title" v-if="errors && errors.length">
                <v-icon color="error">warning</v-icon>
                {{ $t("pagesClients.edit.tenderError") }}: {{ errors }}
              </h2>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { apiCallTrue } from "@/utils/api";
import BidsList from "@/components/verificator/list";
import MyCompany from "@/components/clients/company";
import MyDocuments from "@/components/clients/documents";
import Licences from "@/components/clients/licences";
import Faces from "@/components/clients/faces";
import Owners from "@/components/clients/owners";
import Legals from "@/components/clients/bank";
import Finance from "@/components/clients/finance";
import ClientTenders from "@/components/clients/tenders";
import CloseMessages from "@/components/helpers/CloseMessages";

export default {
  name: "NewClient",
  data: () => ({
    errors: null,
    id: "",
    client: "",
    bids: null,
    bidsLoaded: false,
    bidsErrors: null,
    tenders: [],
    tendersLoaded: false,
    tendersErrors: null,
    company: null,
    companyLoaded: false,
    documents: null,
    documentsLoaded: false,
    licences: null,
    licencesLoaded: false,
    owners: null,
    ownersLoaded: false,
    faces: null,
    facesLoaded: false,
    bank: null,
    bankLoaded: false,
    finances: null,
    financesLoaded: false,
    activeTab: "company",
  }),
  methods: {
    //1step -> next
    onCompanyToFinance() {
      this.$root.$off("onNextCompany");
      let buttonSave = document.getElementById("companySaveButton");
      this.$root.$on("onNextCompany", (valid) => {
        if (valid === true) {
          window.scrollTo(0, 0);
          if (this.isShowFinancial) {
            this.getFinances();
          } else {
            this.getDocuments();
          }
        }
        this.$root.$off("onNextCompany");
      });
      buttonSave.click();
    },

    onCompanyToDocuments() {
      this.$root.$off("onNextFinance");
      let buttonSave = document.getElementById("financeSaveButton");
      this.$root.$on("onNextFinance", (valid) => {
        if (valid === true) {
          window.scrollTo(0, 0);
          this.getDocuments();
        }
        this.$root.$off("onNextFinance");
      });
      buttonSave.click();
    },
    async getCompany(isNotActiveTab, finnalyCallback) {
      this.errors = null;
      this.client = null;
      if (!finnalyCallback) this.activeTab = "company";

      await apiCallTrue({
        url: `v1/agent/clients/${this.id}`,
      })
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.data &&
            response.data.data.clientCompany
          ) {
            this.company = response.data.data.clientCompany;
          } else {
            this.company = {};
          }

          if (
            response &&
            response.data &&
            response.data.data &&
            response.data.data.client
          ) {
            this.client = response.data.data.client;
          } else {
            this.client = {};
          }

          this.companyLoaded = true;
          // this.getBids();
        })
        .catch((error) => {
          this.errors = error.message;
        })
        .finally(() => {
          if (finnalyCallback) {
            finnalyCallback();
          }
        });
    },
    async getBids() {
      this.activeTab = "bids";
      this.errors = null;
      const params = { inn: this.client.inn };

      await apiCallTrue({
        url: "v1/bids",
        params,
      })
        .then((response) => {
          if (response.data.data) {
            this.bids = response.data.data;
          } else {
            this.bids = [];
          }
          this.bidsLoaded = true;
        })
        .catch((error) => {
          this.bidsLoaded = true;
          this.errors = error.message;
        });
    },
    async getTenders() {
      this.activeTab = "tenders";
      this.errors = null;
      const params = {
        inn: this.client ? this.client.inn : -1,
        agent_client_id: this.id,
      };
      this.tenders = [];
      this.tendersLoaded = false;
      this.tendersErrors = null;

      await apiCallTrue({
        url: "v1/tenders/list-by-client",
        params,
      })
        .then((response) => {
          if (response.data.data) {
            this.tenders = response.data.data;
          }
          this.tendersLoaded = true;
        })
        .catch((error) => {
          this.tendersLoaded = true;
          this.errors = error.message;
        });
    },
    async getOwners() {
      this.errors = null;
      const params = { inn: this.client.inn };

      await apiCallTrue({
        url: "v1/founders",
        params,
      })
        .then((response) => {
          this.owners = response.data.data || [];
          this.ownersLoaded = true;
        })
        .catch((error) => {
          this.errors = error.message;
        });
    },

    async getFaces() {
      this.activeTab = "faces";
      this.errors = null;
      const params = { inn: this.client.inn };

      await apiCallTrue({
        url: "v1/officials",
        params,
      })
        .then((response) => {
          this.getOwners();
          this.faces = response.data.data || [];
          this.facesLoaded = true;
        })
        .catch((error) => {
          this.errors = error.message;
        });
    },

    async getBanks() {
      this.activeTab = "bank";
      this.errors = null;
      const params = { inn: this.client.inn };

      await apiCallTrue({
        url: "v1/bank-accounts",
        params,
      })
        .then((response) => {
          this.bank = response.data.data || [];
          this.bankLoaded = true;
        })
        .catch((error) => {
          this.errors = error.message;
        });
    },
    async getDocuments() {
      this.documentsLoaded = false;
      this.activeTab = "documents";
      this.errors = null;
      const params = { inn: this.client.inn, type: 0 };

      if (!this.companyIsTax) {
        this.documentsLoaded = true;
        return;
      }
      await apiCallTrue({
        url: "v1/folders",
        params,
      })
        .then((response) => {
          this.documents = response.data.data.folders;
          this.getLicences();
          this.documentsLoaded = true;
        })
        .catch((error) => {
          this.errors = error.message;
          console.log(error, "docs error");
        });
    },

    async getLicences() {
      this.licencesLoaded = false;
      this.errors = null;
      const params = { inn: this.client.inn };

      await apiCallTrue({
        url: "v1/licenses",
        params,
      })
        .then((response) => {
          this.licences = response.data.data || [];
          this.licencesLoaded = true;
        })
        .catch((error) => {
          this.errors = error.message;
        });
    },
    async getFinances() {
      this.financesLoaded = false;
      this.activeTab = "finances";
      this.errors = null;
      const params = { inn: this.client.inn };

      await apiCallTrue({
        url: "v1/financials",
        params,
      })
        .then((response) => {
          this.finances = response.data.data;
          this.financesLoaded = true;
        })
        .catch((error) => {
          this.errors = error.message;
          this.financesLoaded = true;
        });
    },
    addBid() {
      localStorage.setItem("client_inn", this.client.inn);
      this.$router.push({
        name: "NewBid",
        params: { client: this.client },
      });
    },
    nextTab() {
      return this.activeTab++;
    },
    updateFaces() {
      this.getFaces();
    },
    updateBanks(updatedBank) {
      this.bank.map((bank) => {
        if (bank.id === updatedBank.id) {
          Object.assign(bank, updatedBank);
        }
      });
    },
    addBanks(bank) {
      this.bank.push(bank);
    },

    updateFacesAndFounders() {
      this.getFaces();
      this.getOwners();
    },
    updateOwners() {
      this.getOwners();
    },
    updateDocuments() {
      this.getDocuments();
    },
    updateLicences(licence) {
      this.licences.map((item) => {
        if (item.id === licence.id) {
          Object.assign(item, licence);
        }
      });
    },
    addLicence(licence) {
      this.licences.push(licence);
    },
    onClickTab(tabName) {
      this.$router.push({
        path: `/clients/${this.id}/`,
        query: { tab: tabName },
      });
      this._autoLoadTab(tabName);
    },
    _autoLoadTab(tabName) {
      console.log("_autoLoadTab", tabName);
      switch (tabName) {
        case "tenders":
          {
            this.getTenders();
          }
          break;
        case "bids":
          {
            this.getBids();
          }
          break;
        case "bank":
          {
            this.getBanks();
          }
          break;
        case "faces":
          {
            this.getFaces();
          }
          break;
        case "documents":
          {
            this.getDocuments();
          }
          break;
        case "finances":
          {
            this.getFinances();
          }
          break;

        case "company":
          {
            this.getCompany(this.id);
          }
          break;
      }
    },

    getSocketMessage(message) {
      //console.log("BID CLIENT LIST MESSSAGE", message);
      switch (message.type) {
        case 2:
          if (
            message.action === "updateBidsList" &&
            this.activeTab == "bids" &&
            message.to_users &&
            message.to_users.includes(new String(this.userId).toString())
          ) {
            //console.log("ws BIDS execute");
            this.getBids();
          }
          break;
      }
    },
  },
  mounted() {
    this.id = this.$route.params.id;

    if (this.$route.query.tab) {
      if (this.$route.query.tab != "company") {
        this.getCompany(this.id, () => {
          this._autoLoadTab(this.$route.query.tab);
        });
      } else {
        this.getCompany(this.id);
      }
    } else {
      this.getCompany(this.id);
    }
  },
  components: {
    BidsList,
    MyCompany,
    MyDocuments,
    Licences,
    Faces,
    Owners,
    Legals,
    Finance,
    ClientTenders,
    CloseMessages,
  },
  watch: {
    wSocket(message) {
      this.getSocketMessage(message);
    },
  },
  computed: {
    ...mapState({
      profile: (state) => state.user.profile,
      userId: (state) => state.user.profile.id,
      wSocket: (state) => state.wSocket.message,
    }),
    //Скрываем show Financial
    isShowFinancial() {
      return false;
    },
    isCompanyIndividual() {
      if (this.company) {
        let strCompany = new String(this.company.inn);
        if (strCompany.trim().length == 12) return true;
      }
      return false;
    },
    isShowTender() {
      if (!this.profile) return false;
      if (!this.profile.settings) return false;
      if (!this.profile.settings.services) return false;
      if (!this.profile.settings.services.tender) return false;
      return true;
    },
    companyIsTax() {
      if (!this.company) return false;
      if (!this.company.tax_system) return false;
      return true;
    },
  },
};
</script>
<style lang="scss">
.client {
  &__data {
    &-tab {
      strong {
        display: inline-flex;
        border-bottom: 2px solid transparent;
        padding: 4px 8px 12px;
        color: #666;
        font-size: 12px;
        text-transform: uppercase;
        cursor: pointer;
      }
      &.active {
        strong {
          border-bottom-color: #404ce6;
          color: #000;
        }
      }
    }
  }
}
</style>
